import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importing Custom Pipe
import { HighlightPipe } from './highlight.pipe';

@NgModule({
  declarations: [
    HighlightPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HighlightPipe
  ]
})
export class PipesModule { }
